module.exports = __webpack_public_path__ + "img/sample_08_big.84b58848.gif";